import { createApp, ref } from "vue";

/* Internationalization */
import { i18n } from "./plugins/i18n";

/* UI Framework */
import ElementPlus from "element-plus";
import nl from "element-plus/dist/locale/nl.mjs";
import "element-plus/dist/index.css";

import { Vue3Mq } from "vue3-mq";

// Fabric UI
import "office-ui-fabric-core/dist/css/fabric.min.css";

// Font Awesome Pro: @omnimap2/core-components renders its icons as Font Awesome
// classes (e.g. `<i class="fa-solid fa-bold">`) and expects the host app to
// provide the font/CSS. Pro is used so we have the lighter weights (300/light)
// that match the pre-upgrade styling. Without this, icons render as empty boxes.
import "@fortawesome/fontawesome-pro/css/all.min.css";
import "@fortawesome/fontawesome-pro/css/sharp-light.min.css";
import "@fortawesome/fontawesome-pro/css/sharp-regular.min.css";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import OmniComponents from "@omnimap2/core-components";
import "@omnimap2/core-components/dist/style.css";

const app = createApp(App);
const locale = ref(i18n.global.locale || "nl");

app.use(router);
app.use(store);
app.use(i18n);
app.use(ElementPlus, { locale: nl });
app.use(Vue3Mq, {
  breakpoints: {
    sm: 0,
    md: 576,
    lg: 1025,
  },
  defaultBreakpoint: "sm",
  global: true,
});
app.use(OmniComponents, {
  locale,
  // The old `ui-components` lib used Fabric ("ms") icons, but core-components
  // only supports Font Awesome sub-libraries (solid/regular/light/…) and
  // ignores anything else, defaulting to "solid" - which is what we load above.
  faLibrary: "solid",
  notifyName: "notify",
});

app.mount("#app");
